import React from 'react';
import { useTheme } from 'styled-components';
import * as S from './PhoneNumber.styles';
import { AngleBackIcon, PhoneIcon } from '@/components/UI/Icons/Icons';
import { startCall } from '@/utils/helpers';

interface PhoneNumberProps {
  phoneNumber: string;
  isHidden: boolean;
}

export const PhoneNumber: React.FC<PhoneNumberProps> = ({
  phoneNumber,
  isHidden,
}) => {
  const theme = useTheme();

  function call() {
    if (isHidden) return;
    startCall(phoneNumber);
  }

  return (
    <S.Box
      onClick={call}
      data-testid="ad-contact-number"
      className="owner__phones-link"
    >
      <PhoneIcon width={17} height={17} fill={theme.palette.system.blue} />
      <S.Number $variant="1">{phoneNumber}</S.Number>
      <S.Action $variant="2">
        <AngleBackIcon isRotated />
      </S.Action>
    </S.Box>
  );
};
